import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "./MyApp.css";
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import AppInstall from './AppInstall';

function HomePage() {
  return (
    <div className="image-container">
      <img src="/images/flyer.png" alt="Flyer" />
      <div className="navigation-links">
        <a href="/privacy" className="nav-link">プライバシーポリシー</a>
        <a href="/terms" className="nav-link">利用規約</a>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/tanzakus/:id" element={<AppInstall />} />
        <Route path="/users/:id" element={<AppInstall />} />
        <Route path="*" element={<AppInstall />} />
      </Routes>
    </Router>
  );
}

export default App;
